import React, { createContext, PropsWithChildren, useContext, useEffect, useMemo } from 'react';

import { useAlertsStore, useQueryStore } from '@/configs/store';
import { useLogsMode } from '@/features/logsMode';

import { CalendarViewStore } from './CalendarViewStore';

const CalendarViewStoreContext = createContext<CalendarViewStore | null>(null);

export const CalendarViewProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const queryStore = useQueryStore();
  const alertsStore = useAlertsStore();
  const mode = useLogsMode();
  const store = useMemo(
    () => new CalendarViewStore(queryStore, alertsStore, mode),
    [queryStore, alertsStore, mode],
  );

  useEffect(() => {
    return () => {
      store.destroy();
    };
  }, [store]);

  return (
    <CalendarViewStoreContext.Provider value={store}>{children}</CalendarViewStoreContext.Provider>
  );
};

export const useCalendarViewStore = (): CalendarViewStore => {
  const store = useContext(CalendarViewStoreContext);

  if (!store) {
    throw new Error('useCalendarViewStore must be used within CalendarViewProvider');
  }

  return store;
};
